<div *ngIf="message.twilio.attributes['textMessage']">
  {{ message.twilio.attributes['textMessage'] }}
</div>
<mat-card (click)="openFile()">
  <img
    mat-card-image
    square
    *ngIf="isImageType && message.mediaSource"
    [src]="message.mediaSource"
  />
  <div class="placeholder" *ngIf="isImageType && !message.mediaSource">
    <sn-empty-state icon="panorama"> </sn-empty-state>
  </div>
  <div class="media-icon-container">    
    <sn-icon class="media-icon" *ngIf="isImageType">photo</sn-icon>
    <sn-icon class="media-icon" *ngIf="isAudio">volume_up</sn-icon>
    <sn-icon class="media-icon" *ngIf="!isImageType && !isAudio && !isVideo"
      >insert_drive_file</sn-icon
    >
    <sn-icon class="media-icon" *ngIf="isVideo">movie</sn-icon>
    <div class="media-description">
      <div class="text-truncate">{{ message.twilio.media.filename }}</div>
      <div class="muted-text">
        <small>{{ message.twilio.media.size | snFilesize }}</small>
      </div>
      <audio controls *ngIf="isAudio && message.mediaSource">
        <source src="{{ message.mediaSource }}" type="audio/ogg" />
        <source src="{{ message.mediaSource }}" type="audio/mpeg" />
        {{ 'communication.chat.browserNotSupportAudio' | t }}
      </audio>
      <video width="320" height="240" controls *ngIf="isVideo && message.mediaSource">
        <source src="{{ message.mediaSource }}" type="video/mp4" />
        <source src="{{ message.mediaSource }}" type="video/ogg" />
        {{ 'communication.chat.browserNotSupportVideo' | t }}
      </video>
    </div>
  </div>
  <div class="twilio-body" *ngIf="message?.twilio?.body">
    <span [innerHtml]="message?.twilio?.body | snMarked | snLinkify | snSanitizeHtml"></span>
    <span class="edited" *ngIf="!!message.twilio.lastUpdatedBy">({{ 'common.edited' | t }})</span>
  </div>
</mat-card>
